export default __webpack_public_path__ + "ca6cc0b870f09325e8b774fe05190346.png";